import ChatDispatcher from './ChatDispatcher';
import { getPendingChats, getVisibleChats } from '../chatManager/chatFilters';
import { observer } from 'mobx-react-lite';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import searchCache from 'owa-recipient-cache/lib/selectors/searchCache';
import * as React from 'react';

const styles = require('./UcmaChatView.scss');
const INITIAL_CONTACTS_TO_FETCH = 5;

export interface UcmaChatViewProps {
    target: HTMLElement;
    onDismiss: () => void;
}

export default observer(function UcmaChatView(props: UcmaChatViewProps) {
    const [renderDispatcher, setRenderDispatcher] = React.useState<boolean>(
        searchCache('', INITIAL_CONTACTS_TO_FETCH).length > 0
    );
    React.useEffect(() => {
        let intervalTracker;
        if (!renderDispatcher) {
            let cachedContacts = searchCache('', INITIAL_CONTACTS_TO_FETCH);
            if (cachedContacts.length == 0) {
                intervalTracker = setInterval(() => {
                    cachedContacts = searchCache('', INITIAL_CONTACTS_TO_FETCH);
                    if (cachedContacts.length > 0) {
                        setRenderDispatcher(true);
                        clearInterval(intervalTracker);
                    }
                }, 1000);
            } else {
                setRenderDispatcher(true);
            }
        }
        return () => {
            clearInterval(intervalTracker);
        };
    }, []);

    return (
        <Callout
            onDismiss={props.onDismiss}
            target={props.target}
            directionalHint={DirectionalHint.bottomLeftEdge}
            calloutWidth={300}
            setInitialFocus={true}
            isBeakVisible={false}
            preventDismissOnLostFocus={true}
            layerProps={{
                styles: {
                    root: styles.layerRoot,
                },
            }}>
            {renderDispatcher && (
                <ChatDispatcher
                    currentlyActiveChats={[...getVisibleChats(), ...getPendingChats()]}
                />
            )}
        </Callout>
    );
});
